import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { useNavigate, useParams } from "react-router-dom";
import { DataLibrarySourcesList } from "./DataLibrarySourcesList";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";

import "./DataLibrary.scss";
import { FieldElementSearch } from "../../../../components/list/FieldElementSearch";
import useRedirectToDetailSourceExterne from "../sourceExterne/useRedirectToDetailSourceExterne";
import { useSecureApplication } from "../../../../hooks/KeycloackConnection";
import { TopBar } from "../../../../components/topBar/topBar";

export const renderLoading = () => {
  const skeleton = () => (
    <Column
      header={<Skeleton width="100%" height="20px" />}
      body={<Skeleton className="m-2" width="80%" height="20px" />}
    />
  );
  return (
    <DataTable value={[[], [], [], [], []]}>
      {Array(5).fill(1).map(skeleton)}
    </DataTable>
  );
};

export const DataLibrarySourcesPage = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { callDetailSourceExterne } = useRedirectToDetailSourceExterne();
  const { hasAnyPerm } = useSecureApplication();

  const { sourceCreatedId } = useParams();
  const [search, setSearch] = useState<string>("");
  const [ascendingSort, setAscendingSort] = useState<boolean>(true);

  useEffect(() => {
    if (sourceCreatedId) {
      callDetailSourceExterne(Number(sourceCreatedId));
    }
  }, [sourceCreatedId]);


  const activateNewSource = () => {
    if (hasAnyPerm("gds.manage")) {
      return (
        <Button
          label={"Nouvelle source"}
          disabled={false}
          onClick={() => history("/library/source-externe/")}
          className="m-2 p-button-sm"
          icon="pi pi-plus"
        />
      );
    }
  };

  const buttonDomainManagement = () => {
    return (
      <Button
        className="p-button-text"
        type="button"
        label="Gérer les domaines"
        onClick={() => {
          history("/library/domain-management/");
        }}
      />
    );
  };

  const RightButtons = () => {
    return (
      <>
        <div className="flex mr-1" style={{ alignItems: "center" }}>
          {buttonDomainManagement()}
          {activateNewSource()}
        </div>
      </>
    );
  };

  const sortButton = () => {
    return (
      <img
        src="/images/icon-sort-az.svg"
        alt="sorting sources"
        style={
          ascendingSort
            ? {
                backgroundColor: "#ffffff",
                border: "solid 1px #d0ddea",
                transform: "scaleY(-1)",
              }
            : {
                backgroundColor: "#ffffff",
                border: "solid 1px #d0ddea",
              }
        }
        onClick={() => {
          setAscendingSort(!ascendingSort);
        }}
      />
    );
  };

  return (
    <div className="w-full" style={{height:"100%!important"}}>
      <TopBar
        left={
          <h2>
            {t("title.data-catalog.sources")}
          </h2>
        }
        right={RightButtons()}
      />
      <div className="flex m-4 mt-0 pt-4">
        <div className="flex-grow-1 mr-2">
          <FieldElementSearch
            value={search}
            placeholder={"Nom"}
            changeValue={setSearch}
          />
        </div>
        {sortButton()}
      </div>
      <div>
        <DataLibrarySourcesList
          key={`${search}-${ascendingSort}`}
          search={search}
          ascendingSort={ascendingSort}
        />
      </div>
    </div>
  );
};
